import React, { useEffect, useRef, useState } from 'react'
import cogoToast from '@successtar/cogo-toast'
import { useParams } from 'react-router-dom'
// Assuming Samu has a similar Button component or using basic button for now
// import Button from './Button'
import SimpleKeyboard from 'simple-keyboard'

import 'simple-keyboard/build/css/index.css'

interface PromoModalProps {
  showModal: boolean
  setShowModal: (value: boolean) => void
  onPromoApplied: (discountPercentage: number) => void
}

const PromoModal: React.FC<PromoModalProps> = ({ showModal, setShowModal, onPromoApplied }) => {
  const [input, setInput] = useState<string>('')
  const keyboardRef = useRef<SimpleKeyboard | null>(null)
  const inputRef = useRef<HTMLInputElement | null>(null)
  const { projectId } = useParams()

  useEffect(() => {
    if (showModal) {
      keyboardRef.current = new SimpleKeyboard({
        onChange: (input: string): void => setInput(input),
        layout: {
          default: [
            '` 1 2 3 4 5 6 7 8 9 0 - = {bksp}',
            '{tab} Q W E R T Y U I O P { } |',
            '{lock} A S D F G H J K L : " {enter}',
            '{shift} Z X C V B N M &lt; &gt; ? {shift}',
            '.com @ {space}'
          ]
        }
      })

      return (): void => keyboardRef.current?.destroy()
    }
    return
  }, [showModal])

  const handleSubmitPromo = async (): Promise<void> => {
    try {
      // This fetch call remains the same as it hits the backend API
      const response = await fetch(`${process.env.VITE_API_URL}/api/promos/apply`, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          code: input,
          projectId,
          amount: 100000 // Dummy amount to calculate percentage
        })
      })

      const data = await response.json()
      const isValid = response.ok && data.isValid

      if (isValid) {
        const discountPercentage = (data.discount / 100000) * 100
        onPromoApplied(discountPercentage)

        // Using hardcoded English strings for now, Samu Welcome doesn't use i18n
        cogoToast.success(`Discount of ${discountPercentage}% applied!`)
        setShowModal(false)
        setInput('')
      } else {
        cogoToast.error(data.message || 'Invalid promo code')
      }
    } catch (error) {
      console.error('Error validating promo code:', error)
      cogoToast.error('Error applying promo code')
    }
  }

  if (!showModal) return null

  return (
    <div className="fixed inset-0 bg-black bg-opacity-90 flex flex-col items-center justify-center z-[10]">
      {/* Close Button */}
      <button
        type="button"
        className="absolute top-10 right-10 text-white text-3xl font-bold"
        onClick={() => {
          setShowModal(false)
          setInput('')
        }}
      >
        X
      </button>

      <h2 className="text-white text-5xl font-bold mb-8">Enter Promo Code</h2>

      <div className="flex flex-col items-center w-full max-w-md px-4 mb-64">
        <input
          ref={inputRef}
          className="flex-1 w-full border-4 border-carnabyTan rounded-lg p-3 text-2xl font-bold text-center text-gray-800"
          placeholder="Promo Code"
          value={input}
          readOnly // Make input read-only since keyboardf is used
        />
        {/* Using basic button for now */}
        <button
          onClick={handleSubmitPromo}
          className="mt-4 w-full bg-carnabyTan text-white px-6 py-3 rounded-lg text-2xl font-bold hover:brightness-110"
        >
          Apply
        </button>
      </div>

      <div className="w-full fixed bottom-0 left-0">
        <div id="keyboard" className="simple-keyboard" />
      </div>
    </div>
  )
}

export default PromoModal
